import React, { useEffect, useState } from 'react'
import { createMuiTheme, Fab, MuiThemeProvider, Snackbar, Switch, TableCell, Tooltip, Typography, withStyles } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Loader from 'react-loader-spinner'
import MuiAlert from '@material-ui/lab/Alert';
import editIcon from '../../assets/1@3x.png';
import api from '../api';
import { format } from 'date-fns';
import ReactExport from 'react-data-export';
import ic_downloadFile from '../../assets/ic_downloadFile.png';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import CloseImage from '../../assets/ic_close.png';
import DetailMonitoringReservasi from './detailMonitoringReservasi';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ct = require("../../library/CustomTable");

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const style = {
    position: "sticky",
    zIndex: 110
};

const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()

export default function MonitoringReservasi(props) {
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [detail, setDetail] = useState(null);
    const [dataTable, setDataTable] = useState([])
    const [visibleDetail, setVisibleDetail] = useState(false)
    const [visiblePopUp, setVisiblePopUp] = useState(false)
    const [multiDataSet, setMultiData] = React.useState([])
    const [download, setDownload] = React.useState(false);
    const [tglMulai, setTglMulai] = React.useState(null);
    const [tglMulaiDownload, setTglMulaiDownload] = React.useState(null);
    const [tglSelesai, setTglSelesai] = React.useState(null);
    const [tglSelesaiDownload, setTglSelesaiDownload] = React.useState(null);
    const [loading, setLoading] = React.useState(false)
    const [errorTglMulai, setErrorTglMulai] = React.useState(false)
    const [textErrorTglMulai, setTextErrorTglMulai] = React.useState("")
    const [errorTglSelesai, setErrorTglSelesai] = React.useState(false)
    const [textErrorTglSelesai, setTextErrorTglSelesai] = React.useState("")

    useEffect(() => {
        getDataMonitoringReservasi()
    }, [])

    const getDataMonitoringReservasi = () => {
        api.create().getMonitoringReservasi().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let data = response.data.data.map((item) => {
                            return [
                                item.booking_code,
                                item.patient_name ? item.patient_name : '-',
                                item.doctor_name,
                                item.speciality_name,
                                `${format(new Date(item.telemedicine_date), 'dd MMM yyyy')} ${format(new Date(`2100-01-01 ${item.telemedicine_time}`), 'HH:mm')}`,
                                `Rp. ${item.cost}`,
                                item.status_name,
                                item.id
                            ]
                        })
                        setDataTable(data)
                    }
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const handleDetail = ({ rowData }) => {
        setDetail(rowData)
        setVisibleDetail(true)
    }

    const columns = [{
        name: "Kode Booking",
        options: {
            filter: false,
            sortThirdClickReset: true,
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    }, {
        name: "",
        label: "Nama Pasien",
        options: {
            sortThirdClickReset: true
        }
    }, {
        name: "",
        label: "Dokter",
        options: {
            sortThirdClickReset: true
        }
    }, {
        name: "",
        label: "Spesialisasi",
        options: {
            sortThirdClickReset: true
        }
    }, {
        name: "",
        label: "Tanggal & Jam",
        options: {
            sortThirdClickReset: true
        }
    }, {
        name: "",
        label: "Biaya",
        options: {
            sortThirdClickReset: true
        }
    }, {
        name: "",
        label: "Status",
        options: {
            sortThirdClickReset: true
        }
    }, {
        name: "Aksi",
        options: {
            filter: false,
            customHeadRender: (columnMeta) => (
                <TableCell style={{ ...style, top: 0, backgroundColor: 'white', }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <LightTooltip title={`Detail`} arrow>
                            <button
                                style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent',
                                    marginRight: 20
                                }}
                                onClick={() => handleDetail(tableMeta)}
                            >
                                <img src={editIcon} style={{ width: 30, height: 30 }} />
                            </button>
                        </LightTooltip>
                    </div >
                )
            }
        }
    }
    ];

    const handleDownload = () => {
        if (tglMulaiDownload === null) {
            setErrorTglMulai(true)
            setTextErrorTglMulai("Tanggal Mulai Wajib Diisi")
        } else if (tglSelesaiDownload === null) {
            setErrorTglSelesai(true)
            setTextErrorTglSelesai("Tanggal Selesai Wajib Diisi")
        } else {
            api.create().getMonitoringReservasiByDate(format(new Date(tglMulaiDownload), 'yyyy-MM-dd'), format(new Date(tglSelesaiDownload), 'yyyy-MM-dd')).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        setLoading(true)
                        let dataJadi = []
                        if (response.data.data.length > 0) {
                            let data = []
                            let column = [
                                { title: "Kode Booking", width: { wpx: 80 } },
                                { title: "Dokter", width: { wpx: 80 } },
                                { title: "Spesialisasi", width: { wpx: 80 } },
                                { title: "Nama Pasien", width: { wpx: 80 } },
                                { title: "Tanggal & Jam Telemedicine", width: { wpx: 80 } },
                                { title: "Biaya", width: { wpx: 80 } },
                                { title: "Status", width: { wpx: 80 } },
                            ]
                            response.data.data.map((item) => {
                                data.push([
                                    { value: item.booking_code },
                                    { value: item.doctor_name === null ? '' : item.doctor_name },
                                    { value: item.speciality_name === null ? '' : item.speciality_name },
                                    { value: item.patient_name === null ? '' : item.patient_name },
                                    { value: `${format(new Date(item.telemedicine_date), 'dd MMM yyyy')} ${format(new Date(`2100-01-01 ${item.telemedicine_time}`), 'HH:mm')}` },
                                    { value: `Rp. ${handleSeparator(Number(item.cost))}` },
                                    { value: item.status_name },
                                ])
                            })
                            dataJadi.push({
                                columns: column,
                                data: data
                            })
                            setMultiData(dataJadi)
                            setTglMulaiDownload(null)
                            setTglSelesaiDownload(null)
                            setVisiblePopUp(false)
                            setTimeout(() => {
                                setDownload(true)
                                setLoading(false)
                            }, 3000);
                            setDownload(false)
                        } else {
                            let data = []
                            let column = [
                                { title: "Kode Booking", width: { wpx: 80 } },
                                { title: "Dokter", width: { wpx: 80 } },
                                { title: "Spesialisasi", width: { wpx: 80 } },
                                { title: "Tanggal & Jam Telemedicine", width: { wpx: 80 } },
                                { title: "Biaya", width: { wpx: 80 } },
                                { title: "Status", width: { wpx: 80 } },
                            ]
                            data.push([
                                { value: "-" },
                                { value: "-" },
                                { value: "-" },
                                { value: "-" },
                                { value: "-" },
                                { value: "-" },
                            ])
                            dataJadi.push({
                                columns: column,
                                data: data
                            })
                            setMultiData(dataJadi)
                            setTglMulaiDownload(null)
                            setTglSelesaiDownload(null)
                            setVisiblePopUp(false)
                            setTimeout(() => {
                                setDownload(true)
                                setLoading(false)
                            }, 3000);
                            setDownload(false)
                        }
                    }
                }
            })
        }
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 3000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const handleSeparator = (string) => {
        let val = string.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return val
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            {loading && (loadingComponent)}
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>

            <LightTooltip title={"Download"} arrow>
                <div style={{ backgroundColor: 'white', boxShadow: '0 0 16px 0 rgba(130, 130, 130, 0.25)', position: 'absolute', right: 115, top: 30, zIndex: 10, cursor: 'pointer' }}
                    onClick={() => {
                        setVisiblePopUp(true)
                        setTglMulaiDownload(null)
                        setTglSelesaiDownload(null)
                        forceUpdate()
                    }}
                >
                    <img src={ic_downloadFile} style={{ width: 24, height: 24 }} />
                </div>
            </LightTooltip>
            {download && (
                <ExcelFile hideElement={true} filename={`Report Monitoring Reservasi ${format(new Date(tglMulaiDownload), 'dd-MM-yyyy')} - ${format(new Date(tglSelesaiDownload), 'dd-MM-yyyy')}`}>
                    <ExcelSheet dataSet={multiDataSet} name="Sheet" />
                </ExcelFile>
            )}

            <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={dataTable}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>

            {visibleDetail && (
                <DetailMonitoringReservasi
                    onClose={() => setVisibleDetail(false)}
                    detail={detail}
                />
            )}

            {visiblePopUp && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 800 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18, whiteSpace: 'nowrap' }}>Download Report</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ width: '100%', alignSelf: 'center', padding: 0, textAlign: 'right', maxWidth: "inherit" }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisiblePopUp(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '20px 50px' }}>
                            <div className="column-1">
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="tanggal mulai"
                                            label="Tanggal Mulai"
                                            required={true}
                                            format="dd/MM/yyyy"
                                            maxDate={tglSelesaiDownload ? new Date(tglSelesaiDownload) : new Date()}
                                            value={tglMulaiDownload}
                                            error={errorTglMulai}
                                            helperText={textErrorTglMulai}
                                            onChange={(date) => {
                                                setTglMulaiDownload(date)
                                                setErrorTglMulai(false)
                                                setTextErrorTglMulai("")
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%', margin: 0 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            <div className="column-2">
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="tanggal selesai"
                                            label="Tanggal Selesai"
                                            required={true}
                                            value={tglSelesaiDownload}
                                            format="dd/MM/yyyy"
                                            maxDate={new Date()}
                                            minDate={new Date(tglMulaiDownload)}
                                            error={errorTglSelesai}
                                            helperText={textErrorTglSelesai}
                                            onChange={(date) => {
                                                setTglSelesaiDownload(date)
                                                setErrorTglSelesai(false)
                                                setTextErrorTglSelesai("")
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%', margin: 0 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div onClick={() => setVisiblePopUp(false)} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div onClick={(e) => handleDownload()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Download</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
